import { TeamsModule } from '@/modules/fantasy/teams';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/fantasy/teams/')({
  component: TeamsPage,
});

function TeamsPage() {
  return <TeamsModule />;
}
